// shifts-v1: Banner เตือน "ยังไม่ได้กดเข้างาน"
import React, { useState, useEffect } from 'react';
import API from '../api';
import toast from 'react-hot-toast';

function fmtBkk(ts) {
  if (!ts) return '';
  const d = new Date(ts);
  return d.toLocaleTimeString('th-TH', {
    timeZone: 'Asia/Bangkok',
    hour: '2-digit', minute: '2-digit', hour12: false,
  });
}

function fmtMinutes(seconds) {
  const m = Math.floor(seconds / 60);
  if (m < 1) return 'น้อยกว่า 1 นาที';
  if (m < 60) return `${m} นาที`;
  const h = Math.floor(m / 60);
  const rm = m % 60;
  return rm ? `${h} ชม. ${rm} นาที` : `${h} ชม.`;
}

export default function ShiftReminderBanner({ onPendingChange }) {
  const [pending, setPending] = useState(null);
  const [tick, setTick] = useState(0);
  const [clocking, setClocking] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  async function load() {
    try {
      const { data } = await API.get('/api/shifts/my-pending');
      setPending(data.pending || null);
      // notify parent (ClockButton)
      onPendingChange?.(data.pending || null);
    } catch (e) { /* silent */ }
  }

  useEffect(() => {
    load();
    const id = setInterval(load, 30_000);
    const tickId = setInterval(() => setTick(t => t + 1), 60_000);
    return () => { clearInterval(id); clearInterval(tickId); };
    // eslint-disable-next-line
  }, []);

  async function quickClockIn() {
    setClocking(true);
    try {
      await API.post('/api/time/clock-in');
      toast.success('🟢 เข้างานแล้ว!');
      setPending(null);
      onPendingChange?.(null);
      // dispatch event ให้ ClockButton refresh
      window.dispatchEvent(new CustomEvent('clock-status-changed'));
    } catch (e) {
      toast.error(e.response?.data?.error || 'เข้างานไม่สำเร็จ');
    } finally { setClocking(false); }
  }

  if (!pending || dismissed) return null;

  const isOverdue = pending.urgency === 'overdue';
  const startBkk = fmtBkk(pending.start_at);
  const endBkk   = fmtBkk(pending.end_at);

  let message;
  if (isOverdue) {
    const lateMin = Math.floor(pending.seconds_after_start / 60);
    message = `⚠️ ผ่านเวลาเริ่มกะมาแล้ว ${fmtMinutes(pending.seconds_after_start)} — ยังไม่ได้กดเข้างาน`;
  } else {
    message = `⏰ กะของคุณกำลังจะเริ่ม (${startBkk}) — อย่าลืมกดเข้างาน`;
  }

  return (
    <>
      <style>{`
        @keyframes shift-banner-pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.85; }
        }
        @keyframes shift-banner-shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-1px); }
          75% { transform: translateX(1px); }
        }
      `}</style>
      <div style={{
        background: isOverdue
          ? 'linear-gradient(90deg, #fee2e2, #fecaca)'
          : 'linear-gradient(90deg, #fef3c7, #fde68a)',
        borderBottom: `2px solid ${isOverdue ? '#dc2626' : '#f59e0b'}`,
        padding: '10px 16px',
        display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
        animation: isOverdue ? 'shift-banner-pulse 2s ease-in-out infinite' : undefined,
        position: 'sticky', top: 0, zIndex: 90,
      }}>
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{
            fontSize: 14, fontWeight: 700,
            color: isOverdue ? '#991b1b' : '#92400e',
          }}>
            {message}
          </div>
          <div style={{
            fontSize: 12, marginTop: 2,
            color: isOverdue ? '#7f1d1d' : '#78350f',
          }}>
            🕐 {startBkk}–{endBkk} · 🎭 {pending.role}
            {pending.notes ? ` · 📝 ${pending.notes}` : ''}
          </div>
        </div>
        <button onClick={quickClockIn} disabled={clocking}
          style={{
            background: '#22c55e', color: '#fff', border: 'none',
            padding: '8px 16px', borderRadius: 8, cursor: clocking ? 'wait' : 'pointer',
            fontSize: 13, fontWeight: 700, whiteSpace: 'nowrap',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          }}>
          {clocking ? '...' : '🟢 เข้างานเลย'}
        </button>
        <button onClick={() => setDismissed(true)}
          title="ปิดชั่วคราว (จะกลับมาแสดงเมื่อ refresh)"
          style={{
            background: 'transparent', border: 'none',
            cursor: 'pointer', fontSize: 16, opacity: 0.6,
            padding: '4px 8px',
          }}>×</button>
      </div>
    </>
  );
}
